module.exports = __webpack_public_path__ + "img/publish_icon.7aeaacb.png";